import { announceReady, announceFailure } from "./embed.js";
import { init } from "./scene.js";
try {
  init("scene-container");
  announceReady();
} catch (error) {
  document.getElementById("scene-container").textContent =
    "The 3D view could not start. Please use a browser with WebGL enabled.";
  announceFailure();
  console.error(error);
}
